module.exports = __webpack_public_path__ + "static/img/product15-1.451e059e.png";